{
  "name": "hatch-account-settings-client",
  "description": "This repository houses the front-end code for the Account Settings application.",
  "version": "1.1.0",
  "author": "Hatch",
  "scripts": {
    "build": "npm run clean; NODE_ENV=production parcel build ./src/index.html --public-url /static-account/",
    "clean": "rm -rf dist .parcel-cache",
    "eslint": "eslint --ext .js,.jsx,.ts,.tsx src",
    "start": "parcel -p 1237 src/index.html",
    "test": "jest --passWithNoTests"
  },
  "browserslist": [
    "> 0.5% in US",
    "not ie > 0"
  ],
  "alias": {
    "root": "./src/",
    "hatch-components": "./src/components/atoms/",
    "utils": "./src/utils"
  },
  "dependencies": {
    "@usehatchapp/javascript-sdk": "2.0.164",
    "@usehatchapp/material": "1.2.18",
    "ajv": "^8.12.0",
    "camelcase-keys": "^6.2.2",
    "date-fns": "^2.16.1",
    "dotenv": "^16.3.1",
    "internal-nav-helper": "^3.1.0",
    "launchdarkly-react-client-sdk": "^3.0.8",
    "lodash-es": "^4.17.21",
    "logrocket": "^1.3.0",
    "prop-types": "^15.8.1",
    "react": "^17.0.2",
    "react-content-loader": "^6.2.1",
    "react-dom": "^17.0.2",
    "react-hook-form": "^6.15.8",
    "react-select": "^3.2.0",
    "react-transition-group": "^4.4.1",
    "redux-bundler": "^28.0.3",
    "redux-bundler-hook": "^1.0.3",
    "redux-bundler-react": "^1.2.0",
    "regenerator-runtime": "^0.13.11",
    "styled-components": "^5.3.11",
    "userpilot": "^1.3.0"
  },
  "devDependencies": {
    "@babel/core": "^7.22.10",
    "@babel/plugin-transform-runtime": "^7.22.10",
    "@babel/runtime-corejs2": "^7.22.10",
    "@parcel/packager-raw-url": "^2.12.0",
    "@parcel/transformer-typescript-tsc": "^2.12.0",
    "@parcel/transformer-webmanifest": "^2.12.0",
    "@types/lodash-es": "^4.17.8",
    "@types/react": "^17.0.62",
    "@typescript-eslint/eslint-plugin": "^5.62.0",
    "@usehatchapp/eslint-config": "3.0.0",
    "@usehatchapp/typescript-config": "1.0.3",
    "babel-plugin-add-react-displayname": "^0.0.5",
    "babel-plugin-styled-components": "^2.1.4",
    "browserslist": "^4.21.10",
    "eslint": "^8.46.0",
    "http-proxy-middleware": "^2.0.6",
    "jest": "^29.6.2",
    "parcel": "^2.12.0",
    "prettier": "^2.8.8",
    "react-hot-loader": "^4.13.1",
    "typescript": "^4.9.5"
  },
  "engines": {
    "npm": ">=8.19.1",
    "node": ">=18.9.1"
  },
  "volta": {
    "npm": "8.19.1",
    "node": "18.9.1"
  },
  "private": true,
  "eslintConfig": {
    "extends": "@usehatchapp/eslint-config",
    "rules": {
      "react/jsx-props-no-spreading": "off"
    },
    "overrides": [
      {
        "files": [
          "*.{ts,tsx}"
        ],
        "rules": {
          "no-undef": "off"
        }
      }
    ],
    "ignorePatterns": [
      "dist",
      "node_modules"
    ]
  },
  "prettier": {
    "singleQuote": true,
    "trailingComma": "all"
  }
}
